import { createAction } from '@ngrx/store';

export const articleContentAddedToDOM = createAction(
  '[Article] Last Article Element Component is in DOM (Component AfterViewInit)'
);

export const articleContentRemovedFromDOM = createAction(
  '[Article] Last Article Element Component was removed from DOM (Component OnDestroy)'
);
